import { Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles, useTheme } from "@material-ui/styles";
import CallMadeIcon from "components/common/CallMadeIcon";
import Loading from "components/common/Loading";

import RequestWorkpermitInfo from "components/workpermit/RequestWorkpermitInfo";

import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";

import { HOME_TAB, LTR_STEP } from "libs/constant/Step";
import useAuth from "libs/hooks/useAuth";
import useModalLoading from "libs/hooks/useModalLoading";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHomeTab, setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartFormSlice, addWorkPermit,
  documentRequiredSlice,
  getDocumentRequired, getSmartForm, selectCheckWorkPermit, selectCurrentSmartServiceId,
  selectDocumentRequired, selectSmartServiceLTR, setSmartServiceId
} from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  row: {
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    [theme.breakpoints.up("lg")]: {
      // flexWrap: "nowrap",
    },
  },
  card: {
    // minWidth: 180,
    width: 200,
    height: 230,
    // flex: 1,
    margin: "2% 1%",
    [theme.breakpoints.up("lg")]: {
      // flex: "1 1 23%;",
      margin: "1% 1%",
    },
    borderRadius: 16,
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(3),
    backgroundColor: "red",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      cursor: "pointer",
    },
  },
  wrapIcon: {
    display: "flex",
    flexDirection: "row",
    marginTop: theme.spacing(2),
    flex: 1,
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  typeAlias: {
    marginLeft: 0,
    marginTop: -48,
    width: 37.6,
    textAlign: "center",
    fontSize: 30
  },
  wrapCopyIcon: {
    width: 37.6,
    height: 47,
  },
  type: {
    opacity: 0.7,
  },
  paper: {
    position: "absolute",
    height: "90%",
    width: "90%",
    maxWidth: 1000,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "scroll",
  },
}));

function TypeCard({
  smartserviceId,
  smartserviceName,
  smartserviceFullName,
  description,
  typeAlias,
  color,
  onClick,
}) {
  const classes = useStyles();
  // const typeAlias = description.replace(/\((.*)\)/g, "$1")[0]?.toUpperCase();
  // const typeAlias = description;
  return (
    <div
      className={classes.card}
      style={{ backgroundColor: color }}
      onClick={() => onClick(smartserviceId)}
    >
      <div>
        {/* <Typography variant="subtitle2">{smartserviceName}</Typography> */}
        <Typography variant="h6">{smartserviceFullName}</Typography>
        <Typography variant="body" className={classes.type}>
          {description}
        </Typography>
      </div>
      <div className={classes.wrapIcon}>
        <div className={classes.wrapCopyIcon}>
          <img alt="copy-icon" style={{ width: 50 }} src={"./assets/copy.svg"}></img>
          <Typography variant="h4" className={classes.typeAlias}>
            {typeAlias}
          </Typography>
        </div>
        <CallMadeIcon />
      </div>
    </div>
  );
}

export default function WorkpermitType() {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const modalLoading = useModalLoading();
  const [isRequesting, setRequesting] = useState(false);
  const [isModalSmartTVisible, setModalSmartTVisible] = useState(false);
  const [isModalSmartTFormVisible, setModalSmartTFormVisible] = useState(false);
  const { addSmartForm } = useSmartForm();
  const { personalId } = usePersonalDetail();
  const { TypeOfUser } = useAuth();

  const { isLoading: isLoadingSmartService, data } = useSelector(
    selectSmartServiceLTR
  );
  const { isLoading, isSuccess, isFailure } = useSelector(
    selectDocumentRequired
  );

  const smartserviceId = useSelector(selectCurrentSmartServiceId);
  const checkWorkPermitState = useSelector(selectCheckWorkPermit)

  useEffect(() => {
    if (isRequesting) {
      if (isLoading) {
        modalLoading.showLoading();
      } else if (isSuccess || isFailure) {
        modalLoading.hideLoading();
      }

      if (isSuccess) {
        setRequesting(false);
        setModalSmartTVisible(true);
      }
    }
  }, [isLoading, isSuccess, isFailure, modalLoading, isRequesting]);

  const handleClickStamrtT = (smartserviceId) => {
    setRequesting(true);
    dispatch(setSmartServiceId(smartserviceId));
    dispatch(
      getDocumentRequired({
        smartserviceId, // WPM
        isUpload: false,
        smartserviceGroupID: "LTR",
      })
    );
  };
  const handleStamrtTModalClose = () => {
    setModalSmartTVisible(false);
    dispatch(documentRequiredSlice.actions.clearAsyncState());
  };

  const colorList = [
    theme.palette.turquoiseBlue.main,
    theme.palette.secondary.main,
    theme.palette.primary.main,
    theme.palette.tropaz.main,
    theme.palette.darkIndigo.main,
  ];

  const smartServiceList = [{
    smartserviceId: 'WPM',
    smartserviceName: 'Workpermit',
    smartserviceFullName: 'Workpermit',
    description: 'Workpermit "DWP"',
    typeAlias: 'W',
    color: colorList[0],
    onClick: handleClickStamrtT,
  }]

  const handleSmartTFormSubmit = async () => {
    try {
      modalLoading.showLoading();
      const prepareData = {
        draftId: null,
        smartserviceId,
        personalId,
        survey: null,
        visaissuance: null,
        workpermit: null,
        smartserviceReferId: checkWorkPermitState?.data?.smartserviceReferId ?? null,
        draftIdRef: checkWorkPermitState?.data?.draftIdRef ?? null,
        smartserviceGroupID: "LTR",
        detail: [],
      };
      const response = await dispatch(addWorkPermit({ data: prepareData }));
      await dispatch(getSmartForm({ draftId: response?.payload?.draftId }))
      dispatch(documentRequiredSlice.actions.clearAsyncState());
      dispatch(addSmartFormSlice.actions.clearAsyncState());
      modalLoading.hideLoading();
      setModalSmartTVisible(false);
      setModalSmartTFormVisible(false);
      dispatch(setSmartFormStep(LTR_STEP.UPLOAD_PASSPORT));
      dispatch(
        setHomeTab(HOME_TAB.CHECK_STATUS)
      );
    } catch (error) {
      console.log('error ', error)
      modalLoading.hideLoading();
    }
  };

  return (
    <div className={classes.row}>
      {isLoadingSmartService ? (
        <Loading />
      ) : (
        smartServiceList.map((smartService) => (
          <TypeCard key={smartService.smartserviceId} {...smartService} />
        ))
      )}

      <Dialog
        open={isModalSmartTVisible}
        onClose={handleStamrtTModalClose}
        maxWidth="lg"
      >
        <DialogContent>
          <RequestWorkpermitInfo
            onCancel={handleStamrtTModalClose}
            onSubmit={handleSmartTFormSubmit}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
